"use client";

import Image from "next/image";
import { useTheme } from "@/components/theme-provider";

/** Trimmed horizontal logo on dark (1580×413). */
export const LOGO_HORIZONTAL = { width: 1580, height: 413 } as const;
/** Trimmed stacked logo (dark canvas). */
export const LOGO_STACKED = { width: 1171, height: 768 } as const;

type HorizontalProps = {
  alt: string;
  className?: string;
  priority?: boolean;
};

export function BrandLogoHorizontal({
  alt,
  className = "h-11 w-auto",
  priority,
}: HorizontalProps) {
  const { resolved } = useTheme();
  const src =
    resolved === "dark"
      ? "/brand/logo-horizontal-on-dark.png"
      : "/brand/logo-horizontal-on-light.png";

  return (
    <Image
      key={src}
      src={src}
      alt={alt}
      width={LOGO_HORIZONTAL.width}
      height={LOGO_HORIZONTAL.height}
      className={`object-contain ${className}`}
      sizes="(max-width: 640px) 200px, 280px"
      priority={priority}
    />
  );
}

type StackedProps = {
  alt?: string;
  className?: string;
  priority?: boolean;
};

export function BrandLogoStacked({
  alt = "",
  className = "h-auto w-full max-w-sm",
  priority,
}: StackedProps) {
  const { resolved } = useTheme();
  const src =
    resolved === "dark" ? "/brand/logo-on-dark.png" : "/brand/logo-on-light.png";

  return (
    <Image
      key={src}
      src={src}
      alt={alt}
      width={LOGO_STACKED.width}
      height={LOGO_STACKED.height}
      className={`object-contain ${className}`}
      priority={priority}
    />
  );
}
